import script from "./HDFPartnerBar03.vue?vue&type=script&setup=true&lang=js"
export * from "./HDFPartnerBar03.vue?vue&type=script&setup=true&lang=js"

import "./HDFPartnerBar03.vue?vue&type=style&index=0&id=5612f151&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5612f151"]])

export default __exports__